module.exports = __webpack_public_path__ + "img/InYourFace.d97d3f1a.png";